import React from 'react';
import Img from 'react-image';
import classNames from 'classnames/bind';

import styles from './principios.module.scss';
import starImg from '../../img/star.png';
import handImg from '../../img/hand_shake.png';
import heardImg from '../../img/heart.png';
import rocketImg from '../../img/rocket.png';

let cx = classNames.bind(styles);

const Principios = () => {
	return (
		<section id='principios' className={cx({ principios: true })}>
			<div className='container mx-auto flex flex-col my-4'>
				<div className='flex flex-col text-ccu-green w-full mb-8 pl-8'>
					<p className='text-ccu-dark text-2xl font-bold leading-none font-Roboto-Bold'>
						Nuestros
					</p>
					<h1 className='text-6xl leading-none font-Ubuntu-Bold '>
						Principios
					</h1>
				</div>
				<div className='flex flex-col lg:flex-row mb-8'>
					<div className='flex flex-col w-full lg:w-1/4 bg-ccu-green h-auto lg:mx-6 p-8 text-center items-center'>
						<div className={cx({ img_container: true })}>
							<Img src={starImg} className='w-full' />
						</div>
						<h1 className='text-white font-bold text-2xl font-Roboto-Condensed'>
							Excelencia
						</h1>
						<p className='font-Roboto-Condensed'>
							Somos apasionados por la calidad y el trabajo bien hecho
						</p>
					</div>
					<div className='flex flex-col w-full lg:w-1/4 bg-ccu-blue h-auto lg:mx-6 p-8 text-center items-center'>
						<div className={cx({ img_container: true })}>
							<Img src={handImg} className='w-full' />
						</div>
						<h1 className='text-white font-bold text-2xl font-Roboto-Condensed'>
							Entrega
						</h1>
						<p className='font-Roboto-Condensed'>
							Procuramos el bien de los demás y de nustro entorno, en armonía
							con nuestros legítimos intereses.
						</p>
					</div>
					<div className='flex flex-col w-full lg:w-1/4 bg-ccu-red h-auto lg:mx-6 p-8 text-center items-center'>
						<div className={cx({ img_container: true })}>
							<Img src={heardImg} className='w-full' />
						</div>
						<h1 className='text-white font-bold text-2xl font-Roboto-Condensed'>
							Integridad
						</h1>
						<p className='font-Roboto-Condensed'>
							Cumplimos las normas que nos regulan, siempre inspirados en actuar
							correctamente
						</p>
					</div>
					<div className='flex flex-col w-full lg:w-1/4 bg-ccu-yellow h-auto lg:mx-6 p-8 text-center items-center'>
						<div className={cx({ img_container: true })}>
							<Img src={rocketImg} className='w-full' />
						</div>
						<h1 className='text-white font-bold text-2xl font-Roboto-Condensed'>
							Empoderamiento
						</h1>
						<p className='font-Roboto-Condensed'>
							Nos mueve una actutud emprendedora, innovadora y proactiva
						</p>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Principios;
